/******************************************
 *  Author : vsuthar
 *  Created On : Wed Aug 18 2021
 *  File : index.js
 *  ©Palo Alto Networks
 *******************************************/
import { Card } from '@panwds/react-ui'
import type { VFC, CSSProperties, ReactNode, RefObject } from 'react'

const SideBar: VFC<{ title: ReactNode, children: ReactNode, style?: CSSProperties, treeRef?: RefObject<HTMLDivElement> }> = ({ title, children, style, treeRef }) => {
  return (
    <Card
      shadow='lg'
      className='tw-flex tw-flex-col tw-h-full'
      style={{ boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.24)', minWidth: '264px', height: 'auto', width: '100%' }}
    >
      <div style={{ height: 64 }} className="tw-flex tw-items-center tw-p-3 tw-border-b tw-border-t-0 tw-border-l-0 tw-border-r-0 tw-border-solid tw-border-gray-200 dark:tw-border-gray-950">
        {title}
      </div>
      <div
        ref={treeRef}
        style={style}
        className='tw-flex-1 tw-overflow-auto tw-relative tw-scrollbar-default tw-scrollbar-no-track dark:tw-scrollbar-thumb-dark'
      >
        {children}
      </div>

    </Card>
  )
}

export default SideBar
